import React, { memo, useEffect, useReducer, useState } from 'react'
import Sidebar from './Sidebar'
import Navbar from './Navbar'
import { Outlet } from 'react-router'
import { func } from '../../Utilities/logFunc'
import { isUserPremium } from '../../Utilities/controller'
import { toast } from 'react-toastify'
import ProfileDataProvider from './ProfileContext'


const HomePage = () => {
  const [activeNav, setActiveNav] = useState('')
  // localStorage.setItem("premiumUser",true)
  const [isActiveMenu, seActiveMenu] = useState(false)
  const [isValid, setIsValid] = useState(false)


  useEffect(() => {
    // console.log("Home Page")
    setIsValid(true)

  }, [isValid])

  let mixpanelData = JSON.parse(localStorage.getItem("profile"));

  if (mixpanelData && window.mixpanel) {
    window.mixpanel.identify(mixpanelData?.item?._id || 'USER_ID');
    window.mixpanel.people.set({
      '$distinct_id': mixpanelData?.item?._id,
      '$name': mixpanelData?.item?.gamerjiName,
      '$email': mixpanelData?.item?.email,
      '$phone': mixpanelData?.item?.phone,
      '$phoneCode': mixpanelData?.item?.phoneCode,
      '$user_id': mixpanelData?.item?.user_id,
      '$isEmailVerified': mixpanelData?.item?.isEmailVerified,
      '$isMobileVerified': mixpanelData?.item?.isMobileVerified,
      '$referralCode': mixpanelData?.item?.referralCode,
    });
    window.mixpanel.track('HomePage Loaded', {
      userId: mixpanelData?.item?._id,
      name: mixpanelData?.item?.gamerjiName
    });
  }

  return (
    <ProfileDataProvider>
      <main class="dashboardMain">
        <Sidebar setActiveNav={setActiveNav} seActiveMenu={seActiveMenu} isActiveMenu={isActiveMenu} />
        {
          isValid &&
          <Navbar activeNav={activeNav} seActiveMenu={seActiveMenu} isActiveMenu={isActiveMenu} />
        }

        {/* <Outlet /> */}
        {
          isValid && <Outlet />
        }
      </main>
    </ProfileDataProvider>
  )
}

export default memo(HomePage)